module.exports = __webpack_public_path__ + "img/ic_File_1_active.c9571a37.svg";